module.exports = __webpack_public_path__ + "img/icon-demo-light-white.31accc1d.svg";